import config from 'constants/config';

export const sendUninstallResponse =
  (data, { skipAuth = false } = {}) =>
  (dispatch) => {
    dispatch({
      type: 'SEND_UNINSTALL_REASON',
      payload: {
        endpoint: skipAuth
          ? `${config.apiUrl}/api/v1/feedback/uninstall-extension`
          : 'api/v1/feedback/uninstall-extension',
        method: 'POST',
        body: data,
        custom: skipAuth,
      },
    });
  };
